// BackgroundImage.js

import React from 'react';
import './Background.css';

const BackgroundImage = () => {
  return <div className="background-image">
    
  </div>;
};

export default BackgroundImage;
